import request from '@/utils/request'

const BASE_ROUTE = 'api/v1/vendor-company/'

export const getVendorCompanyList = () =>
  request({
    url: BASE_ROUTE + 'list',
    method: 'get'
  })

export const getVendorCompanyFilteredList = (search: string) =>
  request({
    url: BASE_ROUTE + `filter/${search}`,
    method: 'get'
  })

export const getVendorCompanyById = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}`,
    method: 'get'
  })

export const createVendorCompany = (data: any) =>
  request({
    url: BASE_ROUTE + 'create',
    method: 'post',
    data
  })

export const updateVendorCompany = (id: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/update`,
    method: 'post',
    data
  })

export const deactivateVendorCompany = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}/deactivate`,
    method: 'post'
  })
